export const CHAT_CHANNEL_POLL_INTERVAL = 1000 * 3 // 3 seconds
export const CHAT_CHANNEL_POLL_INTERVAL_WITH_REALTIME = 1000 * 60 * 10 // 10 minutes

export const NOTIFICATIONS_POLL_INTERVAL = 1000 * 20 // 20 seconds
export const NOTIFICATIONS_POLL_INTERVAL_WITH_REALTIME = 1000 * 60 * 10 // 10 minutes

export const DEPLOYMENT_VERSION_POLL_INTERVAL = 1000 * 600 // 10 minutes
